// export const isObject = (obj) => {
//   return obj === Object(obj);
// };

export const isObject = (param) =>
  Object.prototype.toString.call(param) === "[object Object]";

export const serializeObjectInUrlQuery = (obj) => {
  if (isObject(obj)) {
    return new URLSearchParams(obj).toString();
  }
  return;
};
